export default __webpack_public_path__ + "locales/hy-AM/ConvertDialog.json?hash=62bf9b37c8aaf4e49fc8d09a491ab58a";